import ListOfAllShareholdersPDF from "components/generate-pdf/ListOfAllShareholdersPDF";
import { Container } from "react-bootstrap";
import { useParams } from 'react-router';
import fi_translation from 'locale/fi';
import { Spin } from "antd";
import {useEffect, useState } from 'react';
import { convertToObjectKeyString } from "Utils/Common";
// import { useIntl } from 'react-intl';
import { useSearchParams } from "react-router-dom";
import CompanyInformationServices from 'services/services/CompanyInformationServices';
var htmlPdfClient = require("html-pdf-client")

const Locale: any = {
    fi: fi_translation,
};

function ListOfAllShareholdersPDFPage(props: any) {

    // const intl=useIntl();
    const [loading,setLoading] = useState<any>(false)
    const [searchParams] = useSearchParams();
    const showbtn = searchParams.get("showbtn");
    const [printBtn, setPrintBtn] = useState(false);
    const [customerDetails, setCustomerDetails] = useState<any>({});
    const [externalCustomer, setExternalCustomer] = useState<any>(false);


    props = {...props,...useParams()}

    useEffect (() => {
        getCustomerDetails()
    },[]);

    const generatePDF =async () => {
        var element:any = document.getElementById('report');
        setPrintBtn(true);
        var opt = {
            margin:        0.1,
            filename:     'Osakasluettelo '+ customerDetails?.customer_name.trim() + '.pdf',
            image:        { type: 'jpeg', quality: 3 },
            html2canvas:  { scale: 3.6 },
            jsPDF:        { unit: 'pt', format: 'A4', orientation: 'landscape',compressPDF: true },
            // pagebreak:    { mode: 'avoid-all', before: '.page-break' }
            pagebreak:    {  after: ['.page-break'], avoid: ['tr', 'td'] }
        };
        // New Promise-based usage:
        setLoading(true);
        await htmlPdfClient().set(opt).from(element).save();
        setPrintBtn(false);
        setLoading(false);
    }

    const TranslateString = (string:any) => {
        let key:any = convertToObjectKeyString(string);
        // console.log('translate',"\""+key+"\": \""+string+"\",")
        let value = Locale['fi'][key];
        // return value;
        return (value===key) ? string : value;
    };

    function getCustomerDetails() {
        let object: any = {};
        object.customer_id = props?.id;
        setLoading(true);
        CompanyInformationServices
            .getCustomerData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    setCustomerDetails(response?.data?.customer_data)
                    if(response?.data?.loan_data){
                        response?.data?.loan_data.map((item:any) => {
                            if(item?.loan_data_priority && item?.loan_data_priority == '13'){
                                setExternalCustomer(true);
                            }
                        })
                    }
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    return (
        <>
            <Spin spinning={loading} >
                <Container fluid className="pt-2 cu-text-small">
                    <div  id="report">
                        <ListOfAllShareholdersPDF {...useParams()} externalCustomer={externalCustomer} TranslateString={TranslateString}/>
                    </div>
                </Container>
            </Spin>
            <button onClick={generatePDF} type="button" className={"btn btn-sm cu-btn-green my-3 rounded-0" + (showbtn === '0' || printBtn ? ' d-none' : '') }  disabled={loading}>{loading?TranslateString("Please Wait"):TranslateString("Export PDF")}</button>
        </>    
    );
}

export default ListOfAllShareholdersPDFPage;